<template>
  <div v-if="visible" class="modal-overlay" @click.self="cancel">
    <div class="modal-content max-w-sm">
      <div class="p-4">
        <div class="flex items-start space-x-3">
          <div class="flex-shrink-0">
            <i v-if="type === 'danger'" class="pi pi-exclamation-triangle text-2xl text-red-600"></i>
            <i v-else class="pi pi-question-circle text-2xl text-blue-600"></i>
          </div>
          <div class="flex-1">
            <h3 class="text-base font-medium text-gray-900 dark:text-white">
              {{ title }}
            </h3>
            <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
              {{ message }}
            </p>
          </div>
        </div>
        
        <div class="mt-6 flex justify-end space-x-2">
          <BaseButton variant="secondary" @click="cancel">
            {{ cancelText }}
          </BaseButton>
          <BaseButton :variant="type === 'danger' ? 'danger' : 'primary'" @click="confirm">
            {{ confirmText }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from './BaseButton.vue'

interface Props {
  visible: boolean
  title: string
  message: string
  type?: 'default' | 'danger'
  confirmText?: string
  cancelText?: string
}

withDefaults(defineProps<Props>(), {
  type: 'default',
  confirmText: 'Confirmar',
  cancelText: 'Cancelar'
})

const emit = defineEmits<{
  confirm: []
  cancel: []
}>()

const confirm = () => {
  emit('confirm')
}

const cancel = () => {
  emit('cancel')
}
</script>